import { ProductCardSkeleton } from "@/app/components/product/ProductListingSkeleton";

export default function RelatedProductsSkeleton({
  count = 4,
}: {
  count?: number;
}) {
  return (
    <div className="mt-4 flex gap-4 overflow-x-auto pb-2">
      {Array.from({ length: count }).map((_, index) => (
        <div key={`related-product-${index}`} className="w-40 shrink-0">
          <ProductCardSkeleton />
        </div>
      ))}
    </div>
  );
}
